import { detectImagery } from 'actions/designer'
import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DetectImageryState } from 'reducer/designer/detectImagery'
import { getDetectImageryCacheKey } from 'sagas/designerSaga/detectImagery'
import { MapDataTypes } from 'types/map'
import { RootState } from 'types/state'
import { Location4326 } from 'types/studio/structs'

export const useDetectImageryForProject = () => {
  const dispatch = useDispatch()
  const detectImageryState = useSelector((state: RootState) => state.designer.detectImagery)
  const detectImageryStateRef = useRef<DetectImageryState>(detectImageryState)
  detectImageryStateRef.current = detectImageryState

  return function (overrideLocation4326?: Location4326) {
    return new Promise<[MapDataTypes[], number]>((resolve, reject) => {
      let location4326 = overrideLocation4326 || window.AccountHelper.sceneOrigin4326FromSceneOrProject()

      //TODO: should we reject if country is not available?
      let country_iso2 = window.WorkspaceHelper.project?.country_iso2 || ''
      let state = window.WorkspaceHelper.project?.state || ''
      let address = window.WorkspaceHelper.project?.address || ''

      let premiumImgResponse = window.AccountHelper.getIsPremiumImageryAvailable(location4326, country_iso2, state)
      let premiumImgIsAvailable = !!premiumImgResponse.isAvailable

      const expectedDetectImageryCacheKey = getDetectImageryCacheKey(
        location4326,
        country_iso2,
        state,
        premiumImgIsAvailable
      )
      if (detectImageryStateRef.current.cacheKey === expectedDetectImageryCacheKey) {
        resolve([detectImageryStateRef.current.availableMapTypes, detectImageryStateRef.current.timezoneOffset || 0])
        return
      }

      dispatch(
        detectImagery(
          location4326,
          country_iso2,
          state,
          address,
          premiumImgIsAvailable,
          window.WorkspaceHelper.project?.is_lite,
          (res, e) => {
            if (res) resolve([res.availableMapTypes, res.timezoneOffset])
            else reject(e)
          },
          false
        )
      )
    })
  }
}
